import { Box, useMediaQueryContext } from "@drone-js/core";
import type { FunctionComponent } from "react";
import { LottiePlayer } from "./LottiePlayer";

export const HeroImage: FunctionComponent = () => {
    const mediaQuery = useMediaQueryContext();

    function getAspectRatio(query: ReturnType<typeof useMediaQueryContext>) {
        if (query.xl) return "1920/420";
        else if (query.l) return "1920/420";
        else if (query.m) return "1536/640";
        else return "1";
    }

    function getScreenSize(query: ReturnType<typeof useMediaQueryContext>) {
        if (query.xl) return "xl";
        else if (query.l) return "l";
        else if (query.m) return "m";
        else return "s-v3";
    }

    const baseUrl = "https://cdn6.agoda.net/images/agoda-homes/partner-marketing/hero-section/";
    const section = "hero-section-lottie-v2";

    return (
        <Box zIndex={1} width="100%" bottom={0} overflow="visible">
            <LottiePlayer
                path={`${baseUrl + section}/${getScreenSize(mediaQuery)}.json`}
                containerProps={{
                    width: "100%",
                    height: "auto",
                    aspectRatio: getAspectRatio(mediaQuery),
                }}
            />
        </Box>
    );
};
